// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import Promise from "es6-promise";
import FormType from './mixins/FormType';
import GlobalFunctions from './mixins/GlobalFunctions';
import VeeValidate from "vee-validate";
import VueScrollTo from 'vue-scrollto';
import VueCarousel from 'vue-carousel';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Tenancy from './mixins/Tenancy';
import ElementConfig from './mixins/ElementConfig';
import IdleVue from 'idle-vue';
import VuePreventBack from "vue-prevent-back";
import { theme } from './theme.js'

const eventsHub = new Vue()

Promise.polyfill();
Vue.config.API_ENDPOINT = process.env.API_ENDPOINT;
Vue.config.HOST_URL = process.env.HOST_URL;
Vue.config.productionTip = false;
Vue.use(VeeValidate);
Vue.use(VueScrollTo);
Vue.use(VueCarousel);
Vue.use(VueAwesomeSwiper);
Vue.use(VuePreventBack);
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 3000000
})
Vue.mixin(FormType);
Vue.mixin(GlobalFunctions);
Vue.mixin(Tenancy);
Vue.mixin(ElementConfig);
Vue.filter('phone_format', function (phone) {
    let input = phone.replace(/[|&;$%@"<>()+,]/g, "")
    input = input.replace(/\D/g,'').substring(0,10); // First ten digits of input only
    const zip = input.substring(0,3);
    const middle = input.substring(3,6);
    const last = input.substring(6,10);

    if(input.length > 6){phone = `(${zip}) ${middle}-${last}`;}
    else if(input.length > 3){phone = `(${zip}) ${middle}`;}
    else if(input.length > 0){phone = `(${zip}`;}
    return phone
});

var instance = axios.create({
    baseURL: Vue.config.API_ENDPOINT,
    timeout: 300000,
    headers: { "X-Custom-Header": "EVF Portal" }
});

window.axios = instance;

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    template: "<App/>",
    components: { App },
    onIdle() {
        localStorage.removeItem('host');
        localStorage.removeItem('token');
        localStorage.removeItem('watchword');
        localStorage.removeItem('accountType');
        localStorage.removeItem('accountStatus');
        localStorage.removeItem("ClinicEventList")
        this.$router.push({name: 'Home'});
    },
    onActive() {
       
    },
    methods: {
        getTheme() {
            const setStyleProperty = (color) => bodyStyles.setProperty(`--${color}-color`, theme[envTheme][color])
            let bodyStyles = document.body.style;
            const envTheme = process.env.THEME;
            setStyleProperty('primary')
            setStyleProperty('secondary')
            setStyleProperty('background')
            setStyleProperty('primary2')
            setStyleProperty('testimonialBullet')
            setStyleProperty('testimonialBulletActive')
        }
    },
    created() {
        this.getTheme()
    }
});


// WEBPACK FOOTER //
// ./src/main.js